module.exports = " <div class=group_base_info _v-7b439542=\"\"> <div class=avatar _v-7b439542=\"\"> <avatar :src=baseInfo.avatar size=5rem :username=baseInfo.name margin=.4rem border-radius=.4rem _v-7b439542=\"\"></avatar> </div> <span class=name _v-7b439542=\"\">{{ baseInfo.name }}</span> <span class=desc _v-7b439542=\"\">{{ baseInfo.desc }}</span> <open-session _v-7b439542=\"\"></open-session> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-7b439542!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/body/info/GroupBaseInfo.vue
 ** module id = 358
 ** module chunks = 2
 **/